import styled from "styled-components";

const DetailsAndTTLContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 840px;  
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  & > div > div {
    border-radius: 8px;
  }
    
  & > div:last-child > fieldset {
    border-radius: 8px;
  }  
`;

const TypeAndCategoryWrapper = styled.div`
  display: none;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;

  & > div {
     width: auto;
     min-width: auto;
     flex: 1; 
  }
`;

const TimeToLiveContainer = styled.div`
  display: none;
  flex-direction: column;
  gap: 24px;
`;

const TimeToLiveHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;  
  gap: 8px;
    
  & > span:last-child{
      color: ${props => props.theme.colors.davysGrey};
  }  
`;

const TimeToLiveActivationContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
    
  & > div:first-child {
    flex: 1;
  }
  & > div:first-child > div {
     border-radius: 8px; 
  }
  & > div:nth-child(2) {
    flex: 1;
  }
  & > div:last-child {
    flex: 0.36;
  }
  
`;

const NoLimitButton = styled.div`
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;  
  gap: 8px;
  border: 1px solid ${props => props.theme.colors.devysGrey};
  border-radius: 8px;
  padding: 0 16px;  
`;

const ErrorMessage = styled.div`
  font-family: Inter, sans-serif;
  font-weight: 400;
  margin: 0px;
  padding: 2px 20px;
  line-height: 20px;
  letter-spacing: 0px;
  font-size: 12px;
  color: rgb(95, 33, 32);
`;

const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
`;

export {
  DetailsAndTTLContainer,
  DetailsContainer,
  TypeAndCategoryWrapper,
  TimeToLiveContainer,
  TimeToLiveHeader,
  TimeToLiveActivationContainer,
  NoLimitButton,
  ErrorMessage,
  FieldContainer
}